// Google Reviews Data for LA MORRA Ristorante
export const reviewsData = {
    overall: {
        rating: 4.4,
        totalReviews: 538,
        googleUrl: "https://www.google.com/maps/place/Ristorante+LA+MORRA/@48.331216,16.0536389,21z/data=!3m1!5s0x476d73e31ba68a25:0xcd3dc8eb9c35d1c!4m6!3m5!1s0x476d73e3ad751a73:0x1f0c113a563979c7!8m2!3d48.3295944!4d16.0504806!16s%2Fg%2F1tg8hjw4?entry=ttu&g_ep=EgoyMDI1MDgyNC4wIKXMDSoASAFQAw%3D%3D"
    },
    
    featuredReviews: [
        {
            id: 1,
            author: "SSC Office",
            rating: 5,
            date: "",
            text: "Ich bin rundum zufrieden! Nicht nur das gesamte Team überzeugt durch erstklassigen Service und Freundlichkeit, auch der Chef setzt Maßstäbe in Sachen Leadership und Kundenorientierung. Seine Professionalität und sein Engagement sorgen für ein spürbar positives Arbeitsklima, was sich direkt auf den Service auswirkt. Eine echte Empfehlung – hier stimmt einfach alles!",
            helpful: 15
        },
        {
            id: 2,
            author: "Κωνσταντίνα Αργυρίου",
            rating: 5,
            date: "",
            text: "Wir gehen dort wirklich gern hin ☺️ Essen: 5, Service: 5, Ambiente: 5. Reservierung je nach Uhrzeit/Tag möglich. Biergarten/Terrasse und privater Speiseraum verfügbar.",
            helpful: 22
        },
        {
            id: 3,
            author: "Isabelle Fitterer",
            rating: 5,
            date: "",
            text: "Wir haben dort Mittag gegessen und auf der Terrasse auch einen Platz bekommen. Pizza und Nudeln waren sehr gut. Essen: 5, Service: 5, Ambiente: 5. Ruhig, man kann sich gut unterhalten.",
            helpful: 18
        }
    ],
    
    // Additional reviews for rotation
    allReviews: [
        {
            id: 4,
            author: "Alexander Beck",
            rating: 4,
            date: "",
            text: "Pizzateig war für meinen Geschmack etwas weich - in Summe aber alle Speisen sehr gut. Guter Service und angenehme Umgebung, auch wenn man im Shopping Center sitzt.",
            helpful: 8
        },
        {
            id: 5,
            author: "KURDISHPRIDE OG13",
            rating: 5,
            date: "",
            text: "Bereits vor 6 Jahren da, sieht fast noch wie damals aus. Wie immer freundliche zuvorkommende Mitarbeiter anzutreffen! Die Gerichte schmecken ausgezeichnet, Pizzen sind der Hammer. Beste Pizzen in Tulln Umgebung!",
            helpful: 25
        }
    ]
};

// Star rating component generator with partial stars (using Unicode stars)
export function generateStars(rating) {
    const fullStars = Math.floor(rating);
    const partial = rating % 1;
    const emptyStars = 5 - fullStars - (partial > 0 ? 1 : 0);
    
    let stars = '';
    
    // Full stars (filled star ★)
    for (let i = 0; i < fullStars; i++) {
        stars += '<span class="star full-star">★</span>';
    }
    
    // Partial star (half filled)
    if (partial > 0) {
        stars += '<span class="star partial-star">★</span>';
    }
    
    // Empty stars (empty star ☆)
    for (let i = 0; i < emptyStars; i++) {
        stars += '<span class="star empty-star">☆</span>';
    }
    
    return stars;
}

// Format review for display
export function formatReview(review) {
    const avatar = generateAvatar(review.author);
    return {
        ...review,
        starsHtml: generateStars(review.rating),
        truncatedText: review.text.length > 120 ? review.text.substring(0, 120) + '...' : review.text,
        avatar: avatar.html
    };
}

// Get fixed featured reviews (no randomization)
export function getRandomReviews(count = 4) {
    const fixedReviews = [
        reviewsData.featuredReviews[0], // SSC Office
        reviewsData.featuredReviews[1], // Κωνσταντίνα Αργυρίου  
        reviewsData.featuredReviews[2], // Isabelle Fitterer
        reviewsData.allReviews[0]       // Alexander Beck
    ];
    
    return fixedReviews.slice(0, count).map(formatReview);
}

// Generate avatar with initial and fixed color
export function generateAvatar(name) {
    const avatarMap = {
        'SSC Office': { color: '#4CAF50', initial: 'S' }, // Green
        'Κωνσταντίνα Αργυρίου': { color: '#2196F3', initial: 'K' }, // Blue
        'Isabelle Fitterer': { color: '#9C27B0', initial: 'I' }, // Purple  
        'Alexander Beck': { color: '#FF9800', initial: 'A' }, // Orange
        'KURDISHPRIDE OG13': { color: '#F44336', initial: 'K' } // Red
    };
    
    const avatar = avatarMap[name] || { 
        color: '#607D8B', 
        initial: name.charAt(0).toUpperCase() 
    };
    
    return {
        initial: avatar.initial,
        color: avatar.color,
        html: `<div class="review-avatar" style="background-color: ${avatar.color};">${avatar.initial}</div>`
    };
}